<template>
  <form class="vue-vat-form vue-js-taxes-toggle" v-on:change="taxToggle">
    <h3>{{ translations.prices_on_the_website }}</h3>
    <div class="switch switch--horizontal">
      <input name="tax_display_status" value="taxes_included" id="tax-toggle-one" type="radio" :checked="getValue === 'taxes_included'"/>
      <label for="tax-toggle-one" class="switch__label">{{ translations.included_vat }}</label>

      <input name="tax_display_status" value="taxes_excluded" id="tax-toggle-two" type="radio" :checked="getValue === 'taxes_excluded'"/>
      <label for="tax-toggle-two" class="switch__label">{{ translations.excluded_vat }}</label>

      <div class="toggle-outside">
        <div class="toggle-inside"></div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'TaxToggleWells',
  components: {},
  data() {
    return {
      translations: {
        prices_on_the_website: ws_vue_store.translations.prices_on_the_website,
        included_vat : ws_vue_store.translations.included_vat,
        excluded_vat : ws_vue_store.translations.excluded_vat,
      }
    };
  },
  props: {
    taxToggle: {
      type: Function
    }
  },
  computed: {
    getValue(){
      const cookieKey = 'ws_taxes_display_selection';
      const cookieName = `${cookieKey}=`;
      const cookieArray = document.cookie.split(';');

      if (cookieArray.length) {
        // eslint-disable-next-line no-restricted-syntax
        for (let cookie of cookieArray) {
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
          }
          if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
          }
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
